import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppConfigService } from '@com-delta-idp/mnx-utils';
import {
  CHECKIN_CONFIG,
  CHECKIN_SEARCH_TYPE_MAP,
  CHECKIN_SESSION_KEYS,
  CHECKIN_START_FROM,
  CONFIRMATION
} from '../../constants/checkin-session.constant';
import {
  CheckinSessionData,
  CheckinSessionParams,
  UserSessionData
} from '../../interface/checkin-session.interface';

@Injectable({
  providedIn: 'root'
})
export class CheckinSessionStorageService {
  private checkinAwsUrl!: string;

  constructor(private appConfig: AppConfigService) {
    this.appConfig
      .getConfigValue(CHECKIN_CONFIG.SECTION, CHECKIN_CONFIG.AWS_URL_KEY)
      .subscribe((url: string) => {
        this.checkinAwsUrl = url;
      });
  }
  setCheckinSessionStorage(
    params: CheckinSessionParams,
    userSessionData$?: Observable<UserSessionData>
  ): void {
    if (userSessionData$) {
      this.setWithUserSession(
        params,
        userSessionData$,
        CHECKIN_START_FROM.MY_TRIP
      );
    } else {
      this.setDirectly(params, CHECKIN_START_FROM.MY_TRIP);
    }
  }

  private setWithUserSession(
    params: CheckinSessionParams,
    userSessionData$: Observable<UserSessionData>,
    startFrom: string
  ): void {
    userSessionData$.pipe(take(1)).subscribe((userData) => {
      const sessionData = this.buildSessionData(params, userData, startFrom);
      this.populateSessionStorage(sessionData);
      this.redirectToAWSCheckin();
    });
  }

  private setDirectly(params: CheckinSessionParams, startFrom: string): void {
    const sessionData = this.buildSessionData(params, null, startFrom);
    this.populateSessionStorage(sessionData);
    this.redirectToAWSCheckin();
  }

  private buildSessionData(
    params: CheckinSessionParams,
    userData: UserSessionData | null,
    startFrom: string
  ): CheckinSessionData {
    return {
      searchType: CHECKIN_SEARCH_TYPE_MAP[CONFIRMATION],
      confirmationNumber: params.confirmationNumber,
      eTicketNumber: params.eTicketNumber,
      skymilesNumber: params.skymilesNumber || userData?.smNumber,
      lastName: params.lastName || userData?.lastName,
      departureAirport: params.departureAirport,
      startFrom,
      deepLinkFlow: 'true'
    };
  }

  private populateSessionStorage(data: CheckinSessionData): void {
    sessionStorage.setItem(CHECKIN_SESSION_KEYS.SEARCH_TYPE, data.searchType);
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.ETICKET_NUMBER,
      data.eTicketNumber
    );
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.SKYMILES_NUMBER,
      data.skymilesNumber
    );
    sessionStorage.setItem(CHECKIN_SESSION_KEYS.LAST_NAME, data.lastName);
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.CONFIRMATION_NUMBER,
      data.confirmationNumber
    );
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.DEPARTURE_AIRPORT,
      data.departureAirport
    );
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.START_FROM,
      CHECKIN_START_FROM.MY_TRIP
    );
    sessionStorage.setItem(
      CHECKIN_SESSION_KEYS.DEEP_LINK_FLOW,
      data.deepLinkFlow
    );
  }

  private redirectToAWSCheckin(): void {
    window.location.href = this.checkinAwsUrl;
  }
}
